export const EMAIL_CHANGED = 'beta/email_changed';

export const EMAIL_ADD = 'beta/email_add_to_waiting_list';
export const EMAIL_ADD_SUCCESS = 'beta/email_add_to_waiting_list_success';
export const EMAIL_ADD_FAILURE = 'beta/email_add_to_waiting_list_failure';

export const CHECK_BETA_STATUS = 'beta/email_check_beta_status';
export const CHECK_BETA_STATUS_SUCCESS = 'beta/email_check_beta_status_success';
export const CHECK_BETA_STATUS_FAILURE = 'beta/email_check_beta_status_failure';

export const SURVEY_SUBMIT = 'beta/survey_submit';
export const SURVEY_SUBMIT_SUCCESS = 'beta/survey_submit_success';
export const SURVEY_SUBMIT_FAILURE = 'beta/survey_submit_failure';

export const SIGNUP_COMPLETE = 'beta/signup_complete';



// WEBPACK FOOTER //
// ./src/scenes/LandingFlow/actionTypes.js